module.exports = __webpack_public_path__ + "static/media/mlHorizontalHVA.25b68eff.png";